export const normalizeSavedRating = (userRating) => {
	const rating = Number(userRating?.rating);
	return Number.isInteger(rating) && rating >= 1 && rating <= 5 ? rating : 0;
};

export const getSavedRatingForm = (userRating) => ({
	rating: normalizeSavedRating(userRating),
	review: String(userRating?.text ?? ''),
});

export const buildRatingPayload = ({ gameId, rating, reviewComment }) => ({
	app_id: gameId,
	rating,
	text: reviewComment.trim(),
});

export const canRateGame = (gameData) => gameData?.valid_participation === true;
